import {
  makeStyles,
  tokens,
  type GriffelStyle,
} from "@fluentui/react-components";
import type { Appearance } from "../data";

type Styles = {
  tab: GriffelStyle;
  selected: GriffelStyle;
  text: GriffelStyle;
  selectedText: GriffelStyle;
  tabList: GriffelStyle;
};

const inAppV2Styles: Styles = {
  tab: {
    height: "32px",
    backgroundColor: tokens.colorBrandBackground2,
    border: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  selected: {
    height: "32px",
    backgroundColor: tokens.colorBrandBackground,
    border: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  text: {
    fontWeight: "600",
  },
  selectedText: {
    fontWeight: "600",
  },
  tabList: {
    paddingLeft: "5px",
    flexWrap: "wrap",
  },
};

const webV2Styles: Styles = {
  tab: {
    height: "40px",
    backgroundColor: tokens.colorBrandBackground2,
    border: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  selected: {
    height: "40px",
    backgroundColor: tokens.colorBrandBackground,
    border: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  text: {
    fontWeight: "600",
  },
  selectedText: {
    fontWeight: "600",
  },
  tabList: {
    flexWrap: "wrap",
  },
};

const useWebV2Styles = makeStyles(webV2Styles);
const useInAppV2Styles = makeStyles(inAppV2Styles);

export const useStyles = (appearance?: Appearance) => {
  switch (appearance) {
    case "web-v3":
    case "web-v2":
    case "web":
      return useWebV2Styles;
    default:
      return useInAppV2Styles;
  }
};
